export default {
  common: {
    blocking: 'ブロッキング',
    quality: '品質',
    manifold: '多様体',
    watertight: '水密',
    meshReady: 'メッシュ可能',
    notMeshReady: 'メッシュ不可',
    needsRepair: '修復が必要',
    diagnosisFailed: 'Diagnosis に失敗しました',
    diagnosing: '診断中…',
    dismiss: '閉じる',
    backToOriginal: '元に戻る',
    geometry: 'ジオメトリ',
    blockingIssues_one: 'ブロッキング問題 {{count, number}} 件',
    blockingIssues_other: 'ブロッキング問題 {{count, number}} 件',
    qualityIssues: '品質 {{count, number}} 件',
    advisoryCount: '注意 {{count, number}} 件',
    issuesSuffix_one: '問題 {{count, number}} 件',
    issuesSuffix_other: '問題 {{count, number}} 件',
  },
  verdictCard: {
    // "Geometry is clean" refers to the uploaded CAD file passing every
    // topology check. ジオメトリファイル makes the FILE referent explicit.
    clean: 'ジオメトリファイルはクリーンです',
    cleanSubtitle: 'トポロジーや品質の問題は見つかりませんでした',
    meshReady: 'メッシュ可能',
    meshReadySubtitle: '注意レベルの品質問題のみが残っています',
    needsRepair: 'ジオメトリファイルの修復が必要です',
    needsRepairSubtitle_one:
      'メッシュ化の前に確認が必要なブロッキング問題が {{count, number}} 件あります',
    needsRepairSubtitle_other:
      'メッシュ化の前に確認が必要なブロッキング問題が {{count, number}} 件あります',
  },
  verdictLine: {
    diagnosisFailed: 'Diagnosis に失敗しました',
    diagnosing: '診断中…',
    wrap: 'Wrap — 診断なし',
    noSeat: 'Diagnosis のシートなし',
    noSubscription: 'Diagnosis のサブスクリプションなし',
    clean: 'クリーン',
    meshReady: 'メッシュ可能',
    advisory: '· 注意 {{count, number}} 件',
    blockingIssues_one: '件のブロッキング問題',
    blockingIssues_other: '件のブロッキング問題',
    quality: '· 品質 {{count, number}} 件',
  },
  findingsRail: {
    fixInChat: 'チャットで修正',
    fixInChatHint:
      'この問題をアシスタントに伝えます。アシスタントは CAD を編集して修正できます。',
    reviewStep: '診断結果の確認',
    repairStep: '修復',
    repairNotNeeded: '修復は不要です',
    repairGuidance:
      '可能な場合、アップロード時に自動修復が実行されます。残った不具合はCADツールで修正して新しいバージョンをライブラリからアップロードするか、上部バーから診断を再実行してください。',
    beyondRepairTitle: '自動修復の対象外',
    beyondRepairFallback:
      '自動修復では、指摘された問題を修正できませんでした。',
    beyondRepairBody:
      '再実行しても解決しません。ピンチポイントや自己交差などの欠陥には自動修復がありません（ヒーリングはソリッドを潰し、フュージョンには接触点ではなく共有面が必要です）。CAD で修正してください。ボディを結合して共有面を持つ 1 つのソリッドにするか、ピンチを設計上なくします。以前のバージョンならメッシュ化できる場合があります。上で選択し、MeshGen で開いてください（欠陥付近ではセル品質が低下することがあります）。',
    loading: '{{version}} を{{verb}}…',
    simplifyRejectedTitle: '簡略化を却下しました',
    simplifyRejectedBody:
      '提案された CAD 簡略化は破棄されました。以前のバージョンは変更されていません。上で選択して診断結果を確認してください。',
    diagnosisFailedTitle: 'Diagnosis に失敗しました',
    diagnosisFailedFallback:
      'ジオメトリを解析できませんでした。CAD ツールで「ジオメトリの修復」を有効にして再エクスポートしてください。',
    noDiagnosis: 'このジオメトリには利用可能な診断がありません。',
    wrapTitle: 'Wrap インポートには診断はありません',
    wrapBody:
      'Wrap は部品を 1 つのクリーンな水密サーフェスに封止するため、診断するものはありません。そのままメッシュ化できます。',
    wrapPrepNote:
      '前処理はインポート時に設定されます。診断するには、Repair でファイルを再インポートしてください。',
    latestIssuesLabel: '最新の診断済みバージョンの問題',
    blockingTitle: 'ブロッキング — クリーンなメッシュのため修正',
    blockingNote:
      'トポロジーエラー。メッシュ化は実行できますが、失敗したり品質の低いセルを生成したりする場合があります。CAD の修復を推奨します。',
    qualityTitle: '品質 — 注意',
    qualityNote:
      'メッシュ化はブロックしませんが、要素品質が低下する場合があります。',
    showLayer: 'ビューアーで {{layer}} を表示',
    hideLayer: 'ビューアーで {{layer}} を非表示',
    expandBodies: '重なっているボディを表示',
    collapseBodies: '重なっているボディを非表示',
    recommended: '推奨',
    conformalFuseTooltip:
      'これはコンフォーマルなマルチリージョンアセンブリです。フュージョンすると各リージョンが 1 つのボディに統合され（CHT が壊れる）ため、先に確認を求められます。',
    fuseTooltip:
      '冗長で重なり合うソリッドを 1 つの水密ボディにフュージョンします。別々の部品が交差する場合の一般的な修正方法です。保持する前に確認できる新しい CAD バージョンを作成します。',
    simplifyCad: 'CAD を簡略化（ソリッドをフュージョン）',
    keepSeparateTooltip:
      'フュージョンせず、各部品を別々のボディとして残し、コンフォーマル（共有・一致）インターフェースでメッシュ化します。これらの別々のソリッドが意図的な場合に使用します。',
    keepSeparateLink:
      'または別々のボディのまま（コンフォーマルインターフェース）',
    doneIn: '{{verb}}所要時間',
    allChecksPassed:
      'すべての診断チェックに合格しました。このジオメトリを MeshGen で開くか、ファイルを差し替えてから Diagnosis を再実行できます。',
    repairAlreadyAttempted: '修復は試行済み',
    repairWithheld: '自動修復を見送りました',
    alreadyTriedBody:
      'この部品では自動修復を既に実行しましたが解決しなかったため、再試行を続けません。そのまま MeshGen で開く（メッシュ可能な場合）、下で CAD を簡略化する、または修正済みファイルをアップロードしてください。',
    ineligibleOriginBody:
      'このバージョンはあなたが選んだ簡略化または修復から生成されたため、その上で自動修復は実行されません。結果を確認して MeshGen で開くか、別の簡略化を試してください。',
  },
  readinessChips: {
    combinedTooltip:
      'これらは、この特定のジオメトリがシミュレーションの種類ごとにメッシュ化できるかを示します。ある種類には対応していても別の種類には対応しないことがあります。例えば内壁のあるアセンブリは FEA には適しますが外部流れ CFD には適しません。',
    staleTooltip:
      'このジオメトリはメッシュ準備チェックが追加される前に診断されました。Diagnosis を再実行して、シミュレーションの種類ごとにメッシュ化できるかを確認してください。',
    feaReady:
      'FEA（構造/熱/モーダル）に対応。有効なソリッドで、ボリュームとしてメッシュ化できます。マルチボディアセンブリはボディごとのグループ（Volume_1、Volume_2…）として個別にメッシュ化され、ボディ単位の材料/境界条件の割り当てが可能です。フュージョンは不要で、共有された内壁も問題ありません。',
    extReady:
      '外部流れ CFD に対応。風洞でラップしてメッシュ化できるクリーンな閉じたボディです。重なりのないマルチボディアセンブリも可能です。',
    intReady:
      '内部流れ CFD に対応。完全に閉じた内部空洞（流体ボリューム）がこの部品から抽出されました。',
    intNotReady: '内部流れ CFD：{{reason}}。',
    chtReady:
      '共役熱伝達（CHT）に対応。固体＋流体リージョンがコンフォーマルなインターフェースを共有しており、それぞれが一致する共有境界を持つ独立したリージョンとしてメッシュ化されます（フュージョン不要）。一致するインターフェース面/ピンチポイントは想定内で、欠陥ではありません。',
    chtWarn:
      'CHT（コンフォーマルな固体＋流体）向けにメッシュ化可能。インターフェースの自己交差/共有壁のアーティファクトによりシーム付近のセルが低下する場合がありますが、各リージョンはメッシュ化できます。',
    feaNotReadyNotReady:
      'FEA 向けにクリーンではありません：{{reason}}。自己交差するソリッドは無効な要素にメッシュ化されます。求解前に修復してください。',
    feaNotReadyWarn:
      'FEA 向けにクリーンではありません：{{reason}}。修復により要素品質が向上します。',
    extNotReady:
      '外部流れ CFD 向けにクリーンではありません：{{reason}}。メッシュは生成できます（ラッパーは寛容です）が、カットが不明瞭になり結果が低下する場合があります。',
    chtNotReady: 'CHT には未対応：{{reason}}。',
    feaLabel: 'FEA',
    externalLabel: '外部流れ CFD',
    internalLabel: '内部流れ CFD',
    chtLabel: 'CHT',
    readyToMesh: 'メッシュ準備',
    aboutReadiness: 'メッシュ準備について',
    rerunToCheck: 'Diagnosis を再実行して確認してください。',
  },
  inspectorStrip: {
    found: '件検出',
    isolated: '分離済み',
    isolate: '分離',
    closeInspector: 'インスペクターを閉じる',
    overlapPair: 'Vol {{a}} ↔ Vol {{b}}',
    overlapRegions: '×{{count, number}}',
    overlapUnresolved: '未特定 {{count, number}} 件',
    overlapUnresolvedWhy:
      'この診断ではボディを特定できませんでした。ボディ特定より前の診断か、2 つのボディが酷似して判別できない場合です。再診断でもう一度お試しください。',
    overlapCoincident: '面一致',
    overlapInterference: '干渉',
    overlapDepthMm: '{{value}} mm',
    overlapDepthUm: '{{value}} µm',
    overlapSplit:
      '面一致 {{coincident, number}} 件 · 干渉 {{interference, number}} 件',
    overlapAllCoincident: '面一致 {{count, number}} 件',
    overlapAllInterference: '干渉 {{count, number}} 件',
    overlapSelectPair: 'Vol {{a}} ↔ Vol {{b}} を選択',
    overlapOpFor: 'Vol {{a}} ↔ Vol {{b}} の処理',
    overlapOpChoose: '選択…',
    overlapOpCut: 'カット',
    overlapOpFragment: 'フラグメント',
    overlapOpFuse: 'フュージョン',
    overlapOpExclude: '除外',
    overlapCutLoser: 'Vol {{loser}} を削る',
    overlapCutLoserUnknown: '大きい方のボディを削る',
    overlapSwapLoser: '代わりに Vol {{loser}} を削る',
    overlapTreatSelectedNone: '選択したペアを処理',
    overlapTreatSelected_one: '選択した {{count, number}} 組を処理',
    overlapTreatSelected_other: '選択した {{count, number}} 組を処理',
    overlapTreatNone: '処理するペアを 1 組以上選択してください。',
    overlapTreatChooseOp:
      '選択したすべてのペアに処理を選んでください。この診断では計測されていないため、既定値がありません。',
    overlapTreatCompact: '{{count, number}} 組を処理',
    overlapTreatExplainer:
      '重なっている各ペアは、カット・フラグメント・フュージョン・除外のいずれかで処理できます。チェックしたペアはまとめて新しいバージョンとして処理され、承認または却下できます。',
    overlapOpCutMeaning:
      '一方のボディから重なっている材料を取り除き、2 つがちょうど接するようにします。',
    overlapOpFragmentMeaning:
      '重なり部分を独立したボディに分割し、界面を共有します（結合・節点共有）。',
    overlapOpFuseMeaning: '2 つのボディを 1 つに結合します。',
    overlapOpExcludeMeaning:
      '両方をそのまま残し、ペアを意図どおりとして記録します。形状は変わらないため、メッシュは未処理と同じように扱います。',
    overlapCutLoserWhy: '材料を失うボディです。もう一方は形状を保ちます。',
    overlapFeaExplainerLabel: '面一致と干渉が FEA メッシュで意味すること',
    overlapDiagramCoincident: '面がマージされ、両ボディが節点を共有します。',
    overlapDiagramInterference:
      '重なりは独立ボディになります。× は実際の結果ではない縁の応力です。',
    overlapFeaExplainer:
      '「共有節点 — 接合」のメッシュでは：\n\n面一致：通常、面がマージされ、2 つのボディは節点を共有して結合されます。接合部は引張・せん断・圧縮を伝え、開くことはありません。\n\n干渉：重なり部分が両方に結合された小さな独立ボディになり、荷重がそこを通ります。その縁の応力は実際の結果ではありません。面がちょうど接するようにカットしてください。\n\nSimOps のメッシュでは、結合されたペアが「共有面」、マージできなかった面が「未結合ペア」として数えられます。未結合の面は、タイまたは接触ペアを追加するまで荷重を伝えません。結合接合部の縁の応力はメッシュを細かくするほど上がり続けるため、縁から要素数個分離れた位置で読んでください。「独立部品」のメッシュでは何も結合されず、すべての接合部にタイまたは接触ペアが必要で、干渉は先にカットする必要があります。',
    overlapCoincidentFea:
      '互いに接するように描かれた 2 つの面が、ファイルの精度では完全には一致していません。節点共有のメッシュは通常これを 1 つの結合界面にマージします。フラグメントは CAD 上で同じことを行います。',
    overlapInterferenceFea:
      '両方のボディが占有している材料です。節点共有のメッシュでは、両方に結合された小さな独立ボディになり、荷重がそこに集中し、その縁の応力は実際の結果ではありません。カットは一方のボディ（入れ替えない限り大きい方）から取り除くので、2 つはちょうど接し、1 つの結合面としてメッシュされます。',
  },
  approvalPanel: {
    fusing: '冗長なソリッドをフュージョン中{{arrow}}…',
    treating_one: '{{count, number}} 組の重なりを処理中{{arrow}}…',
    treating_other: '{{count, number}} 組の重なりを処理中{{arrow}}…',
    fixing: '修正中：{{defects}}',
    noSimplificationTitle: '簡略化は適用されませんでした',
    noSimplificationFallback: 'CAD 簡略化はジオメトリを改善しませんでした。',
    backToOriginal: '元に戻る',
    eyebrowConformal: 'CAD 簡略化 · コンフォーマル',
    eyebrowFuse: 'CAD 簡略化 · フュージョン',
    eyebrowTreatOverlaps: 'CAD 簡略化 · ペア別',
    reviewTitle: '簡略化されたジオメトリを確認',
    reviewDescription:
      '冗長な内部インターフェースを削除するため CAD を編集しました。',
    reject: '却下',
    approve: '承認',
    before: '変更前',
    after: '変更後',
    afterPending:
      '「変更後」の件数はまだ利用できません。フュージョンされたジオメトリは承認時に完全に診断されます。',
    fusedIn: 'フュージョン所要時間',
    treatedIn: '処理所要時間',
    outcomesTitle: 'ペア別の結果',
    outcomeApplied: '適用済み',
    outcomeRecorded: '記録済み',
    outcomeSkipped: 'スキップ: {{detail}}',
    outcomeFailed: '失敗: {{detail}}',
    treatedTotal: '{{total, number}} 組中 {{treated, number}} 組を処理',
    outcomesHighlightOnSource:
      'ハイライトは、処理後のバージョンが再診断されるまで元のジオメトリに表示されます。',
    treatingPair: '{{pair}} · {{op}}',
    metric: '指標',
    beforeCol: '変更前',
    beforeColLabeled: '変更前 · {{label}}',
    afterCol: '変更後',
    afterColLabeled: '変更後 · {{label}}',
    solids: 'ソリッド',
    pinchPoints: 'ピンチポイント',
    nonManifoldEdges: '非多様体エッジ',
    badWinding: '不正な巻き方向',
    manifold: '多様体',
    watertight: '水密',
    yes: 'はい',
    no: 'いいえ',
  },
  noOpBanner: {
    fallback: 'CAD 簡略化はジオメトリを変更しませんでした。',
    noSimplificationApplied: '簡略化は適用されませんでした。',
    backToOriginal: '元に戻る',
    dismiss: '閉じる',
  },
  report: {
    reportEyebrow: 'Diagnosis レポート',
    geometry: 'ジオメトリ',
    generated: '生成日時',
    meshReady: 'メッシュ可能',
    notMeshReady: 'メッシュ不可',
    meshReadyDescription:
      'ブロッキングとなるトポロジー問題は検出されませんでした。',
    notMeshReadyDescription:
      'ブロッキングとなるトポロジー問題はメッシュ化の前に確認が必要です。',
    advisory: '注意 {{count, number}} 件',
    advisoryDescription: '品質問題は自動的にメッシュ化をブロックしません。',
    meshReadiness: 'メッシュ準備',
    manifold: '多様体',
    watertight: '水密',
    open: '開いている',
    findings: '検出結果',
    blocking: 'ブロッキング',
    quality: '品質',
    noFindings: '検出された問題はありません。',
    versionHistory: 'バージョン履歴',
    yes: 'はい',
    no: 'いいえ',
  },
  reportDialog: {
    title: 'Diagnosis レポート',
    description:
      'レポートを確認するか、ブラウザの印刷ダイアログから保存してください。',
    printSave: '印刷/PDF として保存',
  },
  conformalFuse: {
    title: 'コンフォーマルアセンブリをフュージョンしますか？',
    description:
      'これはコンフォーマルなマルチリージョンアセンブリです（例：CHT の固体＋流体）。フュージョンすると各リージョンが 1 つのボディに統合され、マルチリージョン設定が壊れます。CHT ではそのままメッシュ化できます。コンフォーマルインターフェースには「別々のボディのまま」を使用してください。単一のソリッドを意図する場合（例：別々の二分割としてモデル化した FEA 部品）のみフュージョンしてください。',
    keepSeparate: '別々のまま',
    fuseAnyway: 'それでもフュージョン',
  },
  topBar: {
    draftPill: 'v{{version}} · ドラフト rev {{revision}}',
    exportSource: 'ソースファイルを書き出す',
    studyChip: '添付済みのスタディ: {{study}}',
    // 「診断」— Diagnosis 製品のブランド名称. 他の文案でも同じ字を
    // 使い一貫性を保つ (Diagnosis/MeshGen/SimOps はアイコン + 名前
    // で識別、色では区別しない).
    productName: '診断',
    backToLibrary: 'ライブラリに戻る',
    meshReady: 'メッシュ可能',
    meshableTooltip:
      '{{summary}}。ジオメトリはメッシュ化できますが、セル/結果が低下する場合があります。CAD を修復すると品質が向上します。',
    meshableTooltipNoSummary:
      'ジオメトリはメッシュ化できますが、一部のシミュレーション種類では品質の低いセルが生成される場合があります。CAD を修復すると品質が向上します。',
    meshable: 'メッシュ化可能',
    notReadyTooltip:
      '{{summary}}少なくとも 1 つのシミュレーション種類ではこのジオメトリをメッシュ化できません。メッシュ化の前に CAD を修復してください。',
    notMeshReady: 'メッシュ不可',
    wrapImport: 'Wrap インポート',
    wrapRerunTooltip:
      'Wrap インポートは診断をスキップします。診断するには Repair で再インポートしてください。',
    diagnosisInProgress: 'Diagnosis 実行中…',
    rerunTooltip: 'Diagnosis を再実行',
    rerun: '再実行',
    exportPdf: 'PDF をエクスポート',
    exportOptions: 'エクスポートオプション',
    exportJson: 'JSON をエクスポート',
    savePdfHint:
      '印刷可能なレポートをブラウザのダイアログから PDF として保存します。',
    openInMeshgenDisabled:
      'メッシュ化するにはジオメトリが多様体かつ水密である必要があります',
    openInMeshgenReady: 'このジオメトリを MeshGen で開く',
    openInMeshgenWarn:
      '多様体かつ水密です。指摘された問題は一部残っていますが、メッシュ化できます',
    openInMeshgen: 'MeshGen で開く',
  },
  library: {
    // Library lists uploaded FILES — ジオメトリファイル makes the file
    // referent explicit versus the abstract shape.
    dropTitle: '診断する CAD ファイルをドロップ',
    dropSubtitle:
      'STEP、STP、OBJ、STL · 最大 1 GB — 多様体性・水密性・メッシュ品質をチェック',
    recentGeometries: '最近のジオメトリファイル',
    countLabel: '{{count, number}} 件を診断済み',
    searchPlaceholder: 'ジオメトリファイルを検索…',
    all: 'すべて',
    meshReady: 'メッシュ可能',
    needsRepair: '修復が必要',
    emptyTitle: '診断済みのジオメトリファイルはまだありません',
    emptyTitleFiltered: 'フィルターに一致するジオメトリファイルはありません',
    emptyHint:
      '上で CAD ファイルをアップロードして、最初の Diagnosis を実行してください。',
    emptyHintSearch:
      '読み込み済みのジオメトリファイルに一致するものがありません。スクロールしてさらに読み込むか、別の検索をお試しください。',
    emptyHintFilter: '別のフィルターまたは検索語を試してください。',
    loadingLabel: 'ジオメトリファイルを読み込み中…',
    // `formatRelativeTime` の prefix として渡され、「診断済み 3日前」の
    // 「診断済み」部分になる. 単なる相対時刻ではなく Diagnosis が終わった
    // 時点であることを明示.
    diagnosedPrefix: '診断済み',
    awaitingDiagnosis: '診断待ち',
    notDiagnosed: '未診断',
  },
  libraryRow: {
    geometry: 'ジオメトリファイル',
    diagnosed: '診断日',
    verdict: '判定',
    open: '開く',
  },
  libraryCard: {
    repaired: '修復済み',
  },
  thumbnail: {
    meshReady: 'メッシュ可能',
    needsRepair: '修復が必要',
    failed: '失敗',
    needsApproval: '承認が必要',
    diagnosing: '診断中',
    wrap: 'Wrap',
    notDiagnosed: '未診断',
  },
  viewerPanel: {
    loadingViewer: 'ビューアーを読み込み中…',
  },
  fileTree: {
    files: 'ファイル（{{count, number}}）',
    diagnosing: '診断中…',
    repairing: '修復中…',
    repairFailed: '修復に失敗しました',
    diagnosisFailed: 'Diagnosis に失敗しました',
    clean: 'クリーン',
    doneWith: '完了 · {{summary}}',
    simplifyRejected: '簡略化を却下しました',
    viewVersion: 'バージョン {{num}} を表示（{{origin}}）',
    downloadSourceFile: 'ソースファイルをダウンロード',
    downloadVersion: 'バージョン {{num}} のソースファイルをダウンロード',
  },
  workspace: {
    lineageError: 'ジオメトリのバージョンを読み込めませんでした。',
    fixInChatBusy: 'アシスタントが応答中です。終わるまでお待ちください。',
    dismiss: '閉じる',
    rerunFailed:
      '再実行に失敗しました。以前のバージョンを選択してみてください。',
    simplifyFailed: '簡略化を開始できませんでした。',
    resolveSimplifyFirst:
      'Diagnosis を再実行する前に、簡略化を処理（承認または却下）してください。',
    noGeometryToRediagnose:
      'このバージョンには再診断できるジオメトリがありません。以前のバージョンを選択してください。',
    simplifyAwaitingReview:
      'すでに確認待ちの簡略化があります。先に承認または却下してください。',
    lineageBusy:
      '別のバージョンがまだ診断または修復中です。完了を待ってから簡略化してください。',
    simplifyInFlight: '簡略化はすでに送信中です。',
    verbDiagnosing: '診断',
    verbRepairing: '修復',
    verbDiagnosed: '診断',
    verbRepaired: '修復',
  },
  tagAbbr: {
    non_manifold_edges: '非多様体',
    non_manifold_vertices: '非多様体頂点',
    boundary: '非密閉',
    winding_inconsistent_faces: '巻回不整合',
    self_intersections: '自己交差',
    overlapping_faces: '重複面',
    degenerate_faces: '退化面',
    inter_volume_overlaps: 'ソリッド重複',
    multi_revolution_surfaces: '多回転面',
    sharp_edges: '鋭角エッジ',
    ultra_thin_surfaces: '薄面',
    zero_length_edges: 'ゼロ長',
    sliver_faces: 'スライバ',
    clean: 'クリーン',
  },
  severity: {
    clean: 'ジオメトリはクリーンです',
    critical: '重大',
    blocking: '阻害',
    advisory: '助言',
    issuesDetected: '問題を検出',
  },
  meta: {
    // 「5 ソリッド」 reads as "5 solid bodies" (CAD entities), matching
    // English "5 vol" better than 「5 体積」 (generic mass noun).
    vol: 'ソリッド',
    surf: '面',
    curv: '曲線',
    // 「対角長」— バウンディングボックスの対角線の長さ (対角距離)を明示.
    // 単に「対角」だと「対角の位置」に読めるため、長さの意味を「長」で補う.
    diag: '対角長',
    sa: '表面積',
  },
  layers: {
    non_manifold_edges: { label: '非多様体エッジ' },
    boundary: { label: '開放境界' },
    winding_inconsistent_faces: { label: '不整合な巻き方向' },
    non_manifold_vertices: {
      label: '非多様体頂点',
      hint: 'ピンチポイント',
    },
    // 交線 (crossing line) を明示 — CAD の自己交差は面 vs 面が線状に
    // 交わって生じるため、「線」の語を含める方がジオメトリの文脈に合う.
    self_intersections: { label: '自己交差線' },
    overlapping_faces: { label: '重なり合う面' },
    degenerate_faces: { label: '縮退面' },
    inter_volume_overlaps: { label: 'ソリッド間の重なり' },
    multi_revolution_surfaces: { label: '多回転サーフェス' },
    sharp_edges: { label: 'シャープエッジ' },
    ultra_thin_surfaces: { label: '極薄サーフェス' },
    zero_length_edges: { label: '長さゼロのエッジ' },
    sliver_faces: { label: 'スリバー面' },
  },
  defectDescriptions: {
    non_manifold_edges: {
      what: '3 つ以上の面で共有されるエッジ — メッシャーはそれらをまたぐ体積トポロジーを解決できません。',
      fix: '自動修復はこれらのエッジを縫合または分割します。約 5k を超える場合は手動の CAD クリーンアップを推奨します。',
    },
    boundary: {
      what: '表面が水密なソリッドに閉じない開いたエッジ。',
      fix: '自動修復は小さなすき間を塞ぎます。大きな開口は CAD で欠落した面を追加する必要があります。',
    },
    winding_inconsistent_faces: {
      what: '法線が逆方向を向く隣接した面で、内外の分類が崩れます。',
      fix: '自動修復はシード面から巻き方向を再設定します。',
    },
    non_manifold_vertices: {
      what: 'ピンチポイント（非多様体頂点） — 2 つのソリッドまたは表面が一点で接し、そこで内部が曖昧になります。',
      fix: 'CAD でボディを結合し、一点で接触するのではなく面を共有させてください。自動修復では通常これを解決できません。',
    },
    self_intersections: {
      what: '自身または互いを貫通し、絡み合ったトポロジーを生む表面。',
      fix: 'CAD で交差領域をディフィーチャーまたは修復してください — メッシャーはこれを解決できません。',
    },
    overlapping_faces: {
      what: '同じ空間を占める一致または重なった面。',
      fix: 'CAD で重複した面を削除するか、ボディを結合してください。',
    },
    degenerate_faces: {
      what: '実質的に面積がゼロで、線または点に潰れた面。',
      fix: 'より厳しい許容差で再エクスポートするか、CAD でスリバー特徴を削除してください。',
    },
    inter_volume_overlaps: {
      what: '相互に貫入する別々のソリッドボリューム。',
      fix: 'メッシュ化の前に、CAD でボディをブール和するか分離してください。',
    },
    multi_revolution_surfaces: {
      what: '360° を超えて回転し、自身に折り返す表面。',
      fix: 'CAD で回転を 1 周に切り詰めてください。',
    },
    sharp_edges: {
      what: 'メッシャーの既定の二面角しきい値（30°）より鋭い特徴エッジ。',
      fix: '注意 — 抑制しない限り特徴線として保持されます。',
    },
    ultra_thin_surfaces: {
      what: 'バウンディングボックスの対角の 0.01× より近い表面ペア。退化したセルを生成します。',
      fix: 'Mesh Settings でディフィーチャーまたはローカルサイジングを検討してください。',
    },
    zero_length_edges: {
      what: '端点が一致するエッジ — テッセレーションで長さがゼロです。',
      fix: '注意 — インポート時により細かい弦公差で再テッセレーションしてください。',
    },
    sliver_faces: {
      what: 'ソーステッセレーションでアスペクト比が 50:1 を超える面。',
      fix: '注意 — インポート時により細かい弦公差で再テッセレーションしてください。',
    },
    fallback: {
      what: '診断中に検出されたジオメトリ欠陥。',
      fix: '自動修復は可能な場合に修正を試みます。それ以外の場合は CAD でジオメトリを修復してください。',
    },
  },
} as const;
